__turbopack_context__.v({
  "button": "ButtonLinkMore-module-sass-module__bzR1WG__button",
  "icon": "ButtonLinkMore-module-sass-module__bzR1WG__icon",
});
